import React, { useState, useEffect,useRef  } from "react";
import axios from 'axios';
import { REACT_APP_WORKING_URL, REACT_APP_WORKING_CHATAPI_URL } from '../../Constants'
import DocumentsList from '../../components/DocumentsList/DocumentsList';
import { InputNumber, Form, Input, Radio, Button, message, Spin, Select, Divider,Space, Empty, List, Avatar, theme, Checkbox} from 'antd';
import './QuizGenerator.scss';
import { useNavigate } from "react-router-dom";
import Loading from "../../components/Loading/Loading";
import { EditOutlined, LeftOutlined,MoreOutlined,PlusOutlined } from "@ant-design/icons";
import { createQuestions, createQuiz, createQuizDetail, getQuesBankStatusList, getQuizTheme, getWrongQuesQzNumByThm } from "../../requests";
import { SingleChoiceItem, EditSingleChoiceItem } from "../../components/SingleChoiceItem/SingleChoiceItem";
import { getDocumentListByTheme, getQuestionListByTheme, getNormalDocumentListByTheme } from "../../requests/theme";
import { EditMultipleChoiceItem, MultipleChoiceItem } from "../../components/MultipleChoiceItem/MultipleChoiceItem";
import { updateQuestion } from "../../requests/question";
import { EditQuestionAndAnswerItem, QuestionAndAnswerItem } from "../../components/QuestionAndAnswerItem/QuestionAndAnswerItem";
import QuestionList from "../../components/QuestionList/QuestionList";
import { getSelectedDocumentIds } from "../../tools";
import Menu from "../../components/Menu/Menu";

const { TextArea } = Input;
const modeItens = [
    {value: 1, label: 'Generate quiz from uploaded documents'},
    {value: 2, label: 'Question bank'},
];


function Quiz (props){

    const apiUrl = REACT_APP_WORKING_URL;
    const chatApiUrl =  REACT_APP_WORKING_CHATAPI_URL;
    const [documentsList, setDocumentsList] = useState([]);
    const [theme, setTheme] = useState(null);
    const [fromPage, setFromPage] = useState(null);
    const [toPage, setToPage] = useState(null);
    const [quizType, setQuizType] = useState(null);
    const [messageApi, contextHolder] = message.useMessage();
    const [isPending, setIsPending] = useState(false);
    const [questionNumber, setQuestionNumber] = useState(null);
    const [submitDisabled, setSubmitDisabled] = useState(false);
    // theme select
    const [items, setItems] = useState([]);
    const [name, setName] = useState('');
    const inputRef = useRef(null);
    const [mode, setMode] = useState(1);
    const navigate = useNavigate();
    const [incorrectExcTitle, setIncorrectExcTitle] = useState('');
    const user = JSON.parse(localStorage.getItem('user'));
    const [generated, setGenerated] = useState(false);
    const [questionList, setQuestionList] = useState([]);
    const itemChangeStorageRef = useRef(new Map());
    const [current, setCurrent] = useState(1);
    const [total, setTotal] = useState(1);
    const [pageSize, setPageSize] = useState(10);

    useEffect(() => {

        const func = async ()=>{
            // const p1 = Promise.resolve(axios.post(`${apiUrl}document/getFileListById/${user.user_id}`, {}, {
            //     headers: {
            //         authorization: `Bearer ${user.accessToken}`,
            //     },
            // }));
            // const p2 = Promise.resolve(getQuizTheme(user.user_id));
            // const p3 = Promise.resolve(getQuesBankStatusList(user.user_id));
            // const [res, res2, {inProcessList, completeList}] = await Promise.all([p1, p2, p3]); 
            // setDocumentsList(res.data.map((ele)=>{return {...ele, selected:false}}))
            // setQuesBankIPList(inProcessList);
            // setQuesBankComplList(completeList);
            // setItems(res2.themeList.map(item=>item.tag));

            const themeItems = await getQuizTheme(user.user_id);
            setItems(themeItems.themeList)
        }

        try{
            func();
        }catch(err){
            console.log(err);
        }
    }, [])

    const handleClickFile = (file)=>{
        const newDL = documentsList.slice();
        newDL.forEach(element => {
            if(element.document_id === file.document_id){
                element.selected = !file.selected;
            }else{
                element.selected = false;
            }
        });
        setDocumentsList(newDL);
    }

    const handleThemeChange = async (itemValue)=>{
        const docList = await getNormalDocumentListByTheme(itemValue);
        const quesList = await getQuestionListByTheme(itemValue);
        setTheme(itemValue);
        setDocumentsList(docList);
        setQuestionList(quesList);
    }

    const handleQTChange = (e)=>{
        setQuizType(e.target.value)
    }

    const handleSubmit = async ()=>{
        // if(!mode){
        //     messageApi.error('Please select mode');
        //     return;
        // }
        let fileList;
        if(mode === 1){
            fileList = documentsList.filter((ele)=>
                ele.selected === true
            )
            if(!theme){
                messageApi.error('Please select theme');
                return;
            }
            if(fileList.length === 0){
                messageApi.error('Please select file');
                return;
            }
            if(!fromPage || !toPage || toPage<fromPage){
                messageApi.error('Please enter page range');
                return;
            }
            if(!quizType){
                messageApi.error('Please select quiz type');
                return;
            }
            if(!questionNumber){
                messageApi.error('Please enter question number');
                return;
            }
            const obj = {
                user_id: user.user_id,
                type: quizType,
                question_number: questionNumber,
                page_range: fromPage + "," + toPage,
                document_id: fileList.map(ele=>ele.document_id)[0]
            }

            try{
                messageApi.info('Creating questions... will prompt you when creation is complete.');
                setIsPending(true);
                setSubmitDisabled(true);
                const ql = await createQuestions(obj);
                setSubmitDisabled(false);
                setIsPending(false);
                if(ql.length === 0){
                    messageApi.error('Generate question failed, please retry.');
                    return;
                }
                setQuestionList(ql);
                setTotal(ql.length);
                messageApi.open({
                    type: 'success',
                    content: 'Create questions success',
                    duration: 3,
                });
                setGenerated(true);
            }catch(err){
                messageApi.error(err.message);
            }
        }
    }

    const onModeChange = (v)=>{
        // Set mode value
        setMode(v);
        // Clear other input value
        setFromPage(null);
        setToPage(null);
        setQuizType(null);
        setQuestionNumber(null);
    }
    
    const handleEdit = (item)=>{
        const tempList = questionList.slice();
        tempList.forEach((element, index) => {
            if(element.question_id === item.question_id){
                tempList[index] = {...tempList[index], isEdit: true};
            }
        });
        setQuestionList(tempList);
    }

    const handleMore = (item)=>{
        const tempList = questionList.slice();
        tempList.forEach((element, index) => {
            if(element.question_id === item.question_id){
                tempList[index] = {...tempList[index], isMore: !tempList[index].isMore};
            }
        });
        setQuestionList(tempList);
    }

    const handleConfirm = async (item)=>{
        const tempList = questionList.slice();
        let data;
        tempList.forEach((element, index) => {
            if(element.question_id === item.question_id){
                tempList[index].isEdit = false;
                if(itemChangeStorageRef.current.has(element.question_id)){
                    tempList[index] = {...itemChangeStorageRef.current.get(element.question_id), isEdit: false};
                    data = tempList[index];
                    itemChangeStorageRef.current.delete(element.question_id);
                }
            }
        });
        if(data){
            await updateQuestion(item.question_id, data);
        }
        setQuestionList(tempList);
    }

    const handleCancel = (item)=>{
        const tempList = questionList.slice();
        tempList.forEach((element, index) => {
            if(element.question_id === item.question_id){
                tempList[index] = {...tempList[index], isEdit: false};
            }
        });
        itemChangeStorageRef.current.delete(item.question_id);
        setQuestionList(tempList);
    }

    const handleAnswerChange = (item, changedValues)=>{
        if(itemChangeStorageRef.current.has(item.question_id)){
            itemChangeStorageRef.current.set(item.question_id, {...itemChangeStorageRef.current.get(item.question_id), ...changedValues});
        }else{
            itemChangeStorageRef.current.set(item.question_id, {...item, ...changedValues});
        }
    }

    

    // Generate quiz by configuration
    const renderMode1 = ()=>{
        return (
            <>
                <div className='quiz-content-container' style={{maxHeight: '50%', overflowY: 'auto'}}>
                <span className="fs-5 fw-bold">Theme</span>
                    <Select
                        style={{
                            width: '100%',
                        }}
                        allowClear
                        className="my-ant-input"
                        placeholder="Select quiz theme"
                        onChange={(item)=>{handleThemeChange(item)}}
                        disabled={generated}
                        value={theme}
                        options={items.map((item) => ({
                            label: item.theme_name,
                            value: item.theme_id,
                        }))}
                    />

                </div>
                <div className='quiz-content-container'>

                    <span className="fs-5 fw-bold">Choose Document</span>
                    
                    <div className="doc-list" style={{padding: '10px'}}>
                        <DocumentsList documentsList={documentsList} handleClickFile={handleClickFile}/>
                    </div>
                </div>

                {/* <div className='quiz-content-container'>
                    <Space direction="vertical" style={{width: '100%'}}>
                        <span className="fs-5 fw-bold">Title</span>
                        <Input value={title} placeholder="Create a title for the quiz" maxLength={50} onChange={(e)=>setTitle(e.target.value)} className="my-ant-input" />
                        <div style={{marginTop: '12px'}}></div>
                    </Space>
                </div> */}

                {/* <div className='quiz-content-container'>
                    <Space direction="vertical" style={{width: '100%'}}>
                        <span className="fs-5 fw-bold">Description</span>
                        <TextArea value={description} placeholder="Briefly describe the quiz..." maxLength={200} onChange={(e)=>setDescription(e.target.value)} className="my-ant-textraea"/>
                    </Space>
                </div> */}

                <div className='quiz-content-container'>
                    <Space direction="vertical" style={{width: '100%'}}>
                        <span className="fs-5 fw-bold">Page Range</span>
                        <div className="d-flex justify-content-between">
                            <InputNumber style={{flexGrow: 1}} value={fromPage} placeholder='Start Page' max={toPage} onChange={setFromPage} disabled={generated}/>
                            <span style={{display:'inline-flex', padding: '0 20px', alignItems: 'center'}}>To</span>
                            <InputNumber style={{flexGrow: 1}} value={toPage} placeholder='End Page' onChange={setToPage} disabled={generated}/>
                        </div>
                    </Space>
                </div>

                
                <div className='quiz-content-container'>
                    <Space direction="vertical" style={{width: '100%'}}>
                        <span className="fs-5 fw-bold">Select Quiz Type</span>
                        <Radio.Group onChange={handleQTChange} value={quizType} disabled={generated} >
                            <Radio value={1}>Single Choice</Radio>
                            <Radio value={2}>Multiple Choice</Radio>
                            <Radio value={3}>Q&A</Radio>
                        </Radio.Group>
                    </Space>
                </div>

                <div className='quiz-content-container'>
                    <Space direction="vertical" style={{width: '100%'}}>
                        <span className="fs-5 fw-bold">Question number</span>
                        <InputNumber placeholder='Number of questions created' disabled={generated} style={{width: '100%'}} value={questionNumber} max='10' onChange={setQuestionNumber}/>
                    </Space>
                </div>
                <div className='quiz-content-container quiz-content-no-bgcolor'>
                {!generated ? <Button block type="primary" disabled={submitDisabled} onClick={handleSubmit}>Generate Quiz</Button>:<Divider/>}
                </div>

                

                {generated && <div className='quiz-content-container'>
                <Space direction="vertical" style={{width: '100%'}}>
                    <span className="fs-5 fw-bold">Questions</span>
                    <List
                        itemLayout="vertical"
                        dataSource={questionList}
                        pagination={{position: 'bottom', align: 'center', defaultPageSize: 10, defaultCurrent: current, total:total, onChange: setCurrent, onShowSizeChange: (cur, size)=>{setCurrent(cur); setPageSize(size)}}}
                        renderItem={(item, index) => {
                            switch(item.type){
                                case 1:{
                                    return <List.Item
                                        actions={!item.isEdit ? 
                                            [
                                                <a onClick={()=>handleEdit(item)}><Space><EditOutlined /><span>Edit</span></Space></a>,
                                                <a onClick={()=>handleMore(item)}><Space><MoreOutlined /><span>More</span></Space></a>]
                                            : 
                                            [
                                                <a onClick={()=>handleConfirm(item)}><Space><EditOutlined /><span>Confirm</span></Space></a>,
                                                <a onClick={()=>handleCancel(item)}><Space><EditOutlined /><span>Cancel</span></Space></a>
                                            ]
                                        }
                                    >
                                        {!item.isEdit ? <SingleChoiceItem item={item} index={index} current={current} pageSize={pageSize}/>
                                        :
                                        <EditSingleChoiceItem  item={item} index={index} handleAnswerChange={(changedValues)=>handleAnswerChange(item, changedValues)} current={current} pageSize={pageSize}/>
                                        }
                                    </List.Item>
                                }
                                case 2:{
                                    return <List.Item
                                        actions={!item.isEdit ? 
                                            [
                                                <a onClick={()=>handleEdit(item, index)}><Space><EditOutlined /><span>Edit</span></Space></a>,
                                                <a onClick={()=>handleMore(item, index)}><Space><MoreOutlined /><span>More</span></Space></a>]
                                            : 
                                            [
                                                <a onClick={()=>handleConfirm(item, index)}><Space><EditOutlined /><span>Confirm</span></Space></a>,
                                                <a onClick={()=>handleCancel(item)}><Space><EditOutlined /><span>Cancel</span></Space></a>

                                            ]
                                        }
                                    >
                                        {!item.isEdit ? <MultipleChoiceItem item={item} index={index} current={current} pageSize={pageSize}/>
                                        :
                                        <EditMultipleChoiceItem  item={item} index={index} handleAnswerChange={(changedValues)=>handleAnswerChange(item, changedValues)} current={current} pageSize={pageSize}/>
                                        }
                                    </List.Item>
                                }
                                case 3:{
                                    return <List.Item
                                        actions={!item.isEdit ? 
                                            [
                                                <a onClick={()=>handleEdit(item, index)}><Space><EditOutlined /><span>Edit</span></Space></a>,
                                                <a onClick={()=>handleMore(item, index)}><Space><MoreOutlined /><span>More</span></Space></a>]
                                            : 
                                            [
                                                <a onClick={()=>handleConfirm(item, index)}><Space><EditOutlined /><span>Confirm</span></Space></a>,
                                                <a onClick={()=>handleCancel(item)}><Space><EditOutlined /><span>Cancel</span></Space></a>

                                            ]
                                        }
                                    >
                                        {!item.isEdit ? <QuestionAndAnswerItem item={item} index={index} current={current} pageSize={pageSize}/>
                                        :
                                        <EditQuestionAndAnswerItem  item={item} index={index} handleAnswerChange={(changedValues)=>handleAnswerChange(item, changedValues)} current={current} pageSize={pageSize}/>
                                        }
                                    </List.Item>
                                }
                            }
                            return <List.Item>
                                <List.Item.Meta
                                    avatar={<Avatar src={`https://xsgames.co/randomusers/avatar.php?g=pixel&key=${index}`} />}
                                    title={<a href="https://ant.design">{item.title}</a>}
                                    description="Ant Design, a design language for background applications, is refined by Ant UED Team"
                                />
                            </List.Item>
                        }}
                    />
                </Space>
                </div>}
            </>
        );
    }

    // Generate quiz by own question set


    // // Generate wrong questions answers in a theme
    // const renderMode3 = ()=>{
    //     return <>
    //         <div className='quiz-content-container'>
    //             <Space direction="vertical" style={{width: '100%'}}>
    //             <span className="fs-5 fw-bold">Theme</span>
    //                 <Select
    //                     style={{
    //                         width: '100%',
    //                     }}
    //                     allowClear
    //                     className="my-ant-input"
    //                     placeholder="Select quiz theme"
    //                     onChange={(e)=>onExcThemeChange34(e, 3)}
    //                     dropdownRender={(menu) => (
    //                         <>
    //                             {menu}
    //                             <Divider
    //                                 style={{
    //                                 margin: '8px 0',
    //                                 }}
    //                             />
    //                             <Space
    //                                 style={{
    //                                 padding: '0 8px 4px',
    //                                 }}
    //                             >
    //                                 <Input
    //                                     placeholder="Please enter item"
    //                                     ref={inputRef}
    //                                     value={name}
    //                                     onChange={onNameChange}
    //                                     onKeyDown={(e) => e.stopPropagation()}
    //                                     maxLength={30} 
    //                                 />
    //                                 <Button type="text" icon={<PlusOutlined />} onClick={addItem}>
    //                                     Add item
    //                                 </Button>
    //                             </Space>
    //                         </>
    //                     )}
    //                     options={items.map((item) => ({
    //                         label: item,
    //                         value: item,
    //                     }))}
    //                 />
    //                 <div style={{marginTop: '12px'}}></div>
    //                 <span className="fs-5 fw-bold">Title</span>
    //                 <Input
    //                     value={title}
    //                     placeholder="Create a title for the quiz"
    //                     maxLength={50}
    //                     onChange={(e)=>setTitle(e.target.value)}
    //                     className="my-ant-input" />
    //             </Space>
    //         </div>

    //         <div className='quiz-content-container'>
    //             <Space direction="vertical" style={{width: '100%'}}>
    //                 <span className="fs-5 fw-bold">Description</span>
    //                 <TextArea value={description} placeholder="Briefly describe the quiz..." maxLength={200} onChange={(e)=>setDescription(e.target.value)} className="my-ant-textraea"/>
    //             </Space>
    //         </div>

    //         <div className='quiz-content-container'>
    //             <Space direction="vertical" style={{width: '100%'}}>
    //                 <span className="fs-5 fw-bold">Question number</span>
    //                 <InputNumber placeholder='Number of questions created' style={{width: '100%'}} value={questionNumber} max='10' onChange={setQuestionNumber}/>
    //             </Space>
    //         </div>
    //     </>
    // }

    //    // Generate random questions
    //    const renderMode4 = ()=>{
    //     return <>
    //         <div className='quiz-content-container'>
    //             <Space direction="vertical" style={{width: '100%'}}>
    //             <span className="fs-5 fw-bold">Theme</span>
    //                 <Select
    //                     style={{
    //                         width: '100%',
    //                     }}
    //                     allowClear
    //                     className="my-ant-input"
    //                     placeholder="Select quiz theme"
    //                     onChange={(e) => onExcThemeChange34(e, 4)}
    //                     dropdownRender={(menu) => (
    //                         <>
    //                             {menu}
    //                             <Divider
    //                                 style={{
    //                                 margin: '8px 0',
    //                                 }}
    //                             />
    //                             <Space
    //                                 style={{
    //                                 padding: '0 8px 4px',
    //                                 }}
    //                             >
    //                                 <Input
    //                                     placeholder="Please enter item"
    //                                     ref={inputRef}
    //                                     value={name}
    //                                     onChange={onNameChange}
    //                                     onKeyDown={(e) => e.stopPropagation()}
    //                                     maxLength={30} 
    //                                 />
    //                                 <Button type="text" icon={<PlusOutlined />} onClick={addItem}>
    //                                     Add item
    //                                 </Button>
    //                             </Space>
    //                         </>
    //                     )}
    //                     options={items.map((item) => ({
    //                         label: item,
    //                         value: item,
    //                     }))}
    //                 />
    //                 <div style={{marginTop: '12px'}}></div>
    //                 <span className="fs-5 fw-bold">Title</span>
    //                 <Input
    //                     value={title}
    //                     placeholder="Create a title for the quiz"
    //                     maxLength={50}
    //                     onChange={(e)=>setTitle(e.target.value)}
    //                     className="my-ant-input" />
    //             </Space>
    //         </div>

    //         <div className='quiz-content-container'>
    //             <Space direction="vertical" style={{width: '100%'}}>
    //                 <span className="fs-5 fw-bold">Description</span>
    //                 <TextArea value={description} placeholder="Briefly describe the quiz..." maxLength={200} onChange={(e)=>setDescription(e.target.value)} className="my-ant-textraea"/>
    //             </Space>
    //         </div>

    //         <div className='quiz-content-container'>
    //             <Space direction="vertical" style={{width: '100%'}}>
    //                 <span className="fs-5 fw-bold">Question number</span>
    //                 <InputNumber placeholder='Number of questions created' style={{width: '100%'}} value={questionNumber} max='10' onChange={setQuestionNumber}/>
    //             </Space>
    //         </div>
    //     </>
    // }


    return (
        <div className='quiz'>
            {contextHolder}
            <Loading isPending={isPending} content='Generating...'/>
            {/* <div className='mt-5 d-flex justify-content-between'>
                <Menu/>
                <div className='d-flex align-items-center quiz-title'>QUIZ</div>
            </div> */}

            <div className='container mt-4 mb-4 d-flex justify-content-between flex-column' style={{marginBottom: '20px'}}>
                {/* <LeftOutlined style={{margin: '10px 0 0 0'}} onClick={()=>navigate('/pre-home')}/> */}
                <Menu/>
            </div>
            <div className="quiz-container">
                <div className="quiz-content-container">
                    <Space direction="vertical" style={{width: '100%'}} size='small' className="align-items-center">
                        <h2>Quiz Generator</h2>
                        <span>Choose a mode and options to generate your quiz.</span>
                    </Space>
                    <Space direction="vertical" style={{width: '100%'}}>
                        <span className="fs-5 fw-bold">Select Mode</span>
                        <Select
                            style={{width: '100%'}}
                            options={modeItens}
                            onChange={onModeChange}
                            value={mode}
                        />
                    </Space>
                </div>
                {mode === 1 ? renderMode1() : null}
                {mode === 2 ? <QuestionBank/> : null}
                {/* {mode === 3 ? renderMode3() : null}
                {mode === 4 ? renderMode4() : null} */}



            </div>
        </div>
    );
}

// function QuestionBank(props){
//     const [items, setItems] = useState([]);
//     const [documentsList, setDocumentsList] = useState([]);
//     const [questionList, setQuestionList] = useState([]);
//     const [theme, setTheme] = useState(null);
//     const user = JSON.parse(localStorage.getItem('user'));
//     const [current, setCurrent] = useState(1);
//     const itemChangeStorageRef = useRef(new Map());
//     const totalQuestionListRef = useRef([]);
//     const [total, setTotal] = useState(1);
//     const [pageSize, setPageSize] = useState(10);

//     useEffect(()=>{
//         const func = async()=>{
//             const themeItems = await getQuizTheme(user.user_id);
//             setItems(themeItems.themeList)
//         }
//         func();
//     }, [])

//     const handleThemeChange = async (itemValue)=>{
//         const docList = await getDocumentListByTheme(itemValue);
//         const quesList = await getQuestionListByTheme(itemValue);
//         setTheme(itemValue);
//         setDocumentsList(docList);
//         setQuestionList(quesList);
//         totalQuestionListRef.current = quesList;
//         setTotal(quesList.length);
//     }

//     const handleClickFile = (file)=>{
//         const newDL = documentsList.slice();
//         newDL.forEach(element => {
//             if(element.document_id === file.document_id){
//                 element.selected = !file.selected;
//             }else{
//                 element.selected = false;
//             }
//         });
//         const tempQL = totalQuestionListRef.current.filter(ele=>ele.document_id === file.document_id);
//         setDocumentsList(newDL);
//         setQuestionList(tempQL);
//         setTotal(tempQL.length);
//         setCurrent(1);
//     }

   
//     const handleEdit = (item)=>{
//         const tempList = questionList.slice();
//         tempList.forEach((element, index) => {
//             if(element.question_id === item.question_id){
//                 tempList[index] = {...tempList[index], isEdit: true};
//             }
//         });
//         setQuestionList(tempList);
//     }

//     const handleMore = (item)=>{
//         const tempList = questionList.slice();
//         tempList.forEach((element, index) => {
//             if(element.question_id === item.question_id){
//                 tempList[index] = {...tempList[index], isMore: !tempList[index].isMore};
//             }
//         });
//         setQuestionList(tempList);
//     }

//     const handleConfirm = async (item)=>{
//         const tempList = questionList.slice();
//         let data;
//         tempList.forEach((element, index) => {
//             if(element.question_id === item.question_id){
//                 tempList[index].isEdit = false;
//                 if(itemChangeStorageRef.current.has(element.question_id)){
//                     tempList[index] = {...itemChangeStorageRef.current.get(element.question_id), isEdit: false};
//                     data = tempList[index];
//                     itemChangeStorageRef.current.delete(element.question_id);
//                 }
//             }
//         });
//         if(data){
//             await updateQuestion(item.question_id, data);
//         }
//         setQuestionList(tempList);
//     }

//     const handleCancel = (item)=>{
//         const tempList = questionList.slice();
//         tempList.forEach((element, index) => {
//             if(element.question_id === item.question_id){
//                 tempList[index] = {...tempList[index], isEdit: false};
//             }
//         });
//         itemChangeStorageRef.current.delete(item.question_id);
//         setQuestionList(tempList);
//     }

//     const handleAnswerChange = (item, changedValues)=>{
//         if(itemChangeStorageRef.current.has(item.question_id)){
//             itemChangeStorageRef.current.set(item.question_id, {...itemChangeStorageRef.current.get(item.question_id), ...changedValues});
//         }else{
//             itemChangeStorageRef.current.set(item.question_id, {...item, ...changedValues});
//         }
//     } 


//     return <>
//         <div className='quiz-content-container'>
//             <span className="fs-5 fw-bold">Theme</span>
//                 <Select
//                     style={{
//                         width: '100%',
//                     }}
//                     allowClear
//                     className="my-ant-input"
//                     placeholder="Select quiz theme"
//                     value={theme}
//                     onChange={handleThemeChange}
//                     options={items.map((item) => ({
//                         label: item.theme_name,
//                         value: item.theme_id,
//                     }))}
//                 />
//             {/* <Space direction="vertical" style={{width: '100%'}}>
//                 <span className="fs-5 fw-bold">Generating in progress</span>
//                 <DocumentsList documentsList={quesBankIPList} handleClickFile={handleQuesBankIPClick}/>
//                 <span className="fs-5 fw-bold">Ready question bank</span>
//                 <DocumentsList documentsList={quesBankComplList} handleClickFile={handleQuesBankCompClickFile}/>
//             </Space> */}
//         </div>
        
//         <div className='quiz-content-container'>

//             <span className="fs-5 fw-bold">Choose Document</span>
//             <div className="doc-list" style={{padding: '10px'}}>
//                 <DocumentsList documentsList={documentsList} handleClickFile={handleClickFile}/>
//             </div>
//         </div>

//         {(theme !== null) &&<div className='quiz-content-container'>
//             <Space direction="vertical" style={{width: '100%'}}>
//                 <span className="fs-5 fw-bold">Questions</span>
//                 <List
//                     itemLayout="vertical"
//                     dataSource={questionList}
//                     pagination={{position: 'bottom', align: 'center', defaultPageSize: 10, defaultCurrent: current, total:total, onChange: setCurrent, onShowSizeChange: (cur, size)=>{setCurrent(cur); setPageSize(size)}}}
//                     renderItem={(item, index) => {
//                         switch(item.type){
//                             case 1:{
//                                 return <List.Item
//                                     actions={!item.isEdit ? 
//                                         [
//                                             <a onClick={()=>handleEdit(item)}><Space><EditOutlined /><span>Edit</span></Space></a>,
//                                             <a onClick={()=>handleMore(item)}><Space><MoreOutlined /><span>More</span></Space></a>]
//                                         : 
//                                         [
//                                             <a onClick={()=>handleConfirm(item)}><Space><EditOutlined /><span>Confirm</span></Space></a>,
//                                             <a onClick={()=>handleCancel(item)}><Space><EditOutlined /><span>Cancel</span></Space></a>
//                                         ]
//                                     }
//                                 >
//                                     {!item.isEdit ? <SingleChoiceItem item={item} index={index} current={current} pageSize={pageSize}/>
//                                     :
//                                     <EditSingleChoiceItem  item={item} index={index} handleAnswerChange={(changedValues)=>handleAnswerChange(item, changedValues)} current={current} pageSize={pageSize}/>
//                                     }
//                                 </List.Item>
//                             }
//                             case 2:{
//                                 return <List.Item
//                                     actions={!item.isEdit ? 
//                                         [
//                                             <a onClick={()=>handleEdit(item, index)}><Space><EditOutlined /><span>Edit</span></Space></a>,
//                                             <a onClick={()=>handleMore(item, index)}><Space><MoreOutlined /><span>More</span></Space></a>]
//                                         : 
//                                         [
//                                             <a onClick={()=>handleConfirm(item, index)}><Space><EditOutlined /><span>Confirm</span></Space></a>,
//                                             <a onClick={()=>handleCancel(item)}><Space><EditOutlined /><span>Cancel</span></Space></a>

//                                         ]
//                                     }
//                                 >
//                                     {!item.isEdit ? <MultipleChoiceItem item={item} index={index} current={current} pageSize={pageSize}/>
//                                     :
//                                     <EditMultipleChoiceItem  item={item} index={index} handleAnswerChange={(changedValues)=>handleAnswerChange(item, changedValues)} current={current} pageSize={pageSize}/>
//                                     }
//                                 </List.Item>
//                             }
//                             case 3:{
//                                 return <List.Item
//                                     actions={!item.isEdit ? 
//                                         [
//                                             <a onClick={()=>handleEdit(item, index)}><Space><EditOutlined /><span>Edit</span></Space></a>,
//                                             <a onClick={()=>handleMore(item, index)}><Space><MoreOutlined /><span>More</span></Space></a>]
//                                         : 
//                                         [
//                                             <a onClick={()=>handleConfirm(item, index)}><Space><EditOutlined /><span>Confirm</span></Space></a>,
//                                             <a onClick={()=>handleCancel(item)}><Space><EditOutlined /><span>Cancel</span></Space></a>

//                                         ]
//                                     }
//                                 >
//                                     {!item.isEdit ? <QuestionAndAnswerItem item={item} index={index} current={current} pageSize={pageSize}/>
//                                     :
//                                     <EditQuestionAndAnswerItem  item={item} index={index} handleAnswerChange={(changedValues)=>handleAnswerChange(item, changedValues)} current={current} pageSize={pageSize}/>
//                                     }
//                                 </List.Item>
//                             }
//                         }
//                     }}
//                 />
//             </Space>
//         </div>}
//     </> 
// }

function QuestionBank(props){
    const [items, setItems] = useState([]);
    const [documentsList, setDocumentsList] = useState([]);
    const [questionList, setQuestionList] = useState([]);
    const [theme, setTheme] = useState(null);
    const user = JSON.parse(localStorage.getItem('user'));
    const totalQuestionListRef = useRef([]);

    useEffect(()=>{
        const func = async()=>{
            const themeItems = await getQuizTheme(user.user_id);
            setItems(themeItems.themeList)
        }
        func();
    }, [])

    const handleThemeChange = async (itemValue)=>{
        const docList = await getDocumentListByTheme(itemValue);
        const quesList = await getQuestionListByTheme(itemValue);
        setTheme(itemValue);
        setDocumentsList(docList);
        setQuestionList(quesList);
        totalQuestionListRef.current = quesList;
    }

    const handleClickFile = (file)=>{
        const newDL = documentsList.slice();
        newDL.forEach(element => {
            if(element.document_id === file.document_id){
                element.selected = !file.selected;
            }else{
                element.selected = false;
            }
        });
        const tempQL = totalQuestionListRef.current.filter(ele=>ele.document_id === file.document_id);
        setDocumentsList(newDL);
        setQuestionList(tempQL);
    }


    return <>
        <div className='quiz-content-container'>
            <span className="fs-5 fw-bold">Theme</span>
                <Select
                    style={{
                        width: '100%',
                    }}
                    allowClear
                    className="my-ant-input"
                    placeholder="Select quiz theme"
                    value={theme}
                    onChange={handleThemeChange}
                    options={items.map((item) => ({
                        label: item.theme_name,
                        value: item.theme_id,
                    }))}
                />
            {/* <Space direction="vertical" style={{width: '100%'}}>
                <span className="fs-5 fw-bold">Generating in progress</span>
                <DocumentsList documentsList={quesBankIPList} handleClickFile={handleQuesBankIPClick}/>
                <span className="fs-5 fw-bold">Ready question bank</span>
                <DocumentsList documentsList={quesBankComplList} handleClickFile={handleQuesBankCompClickFile}/>
            </Space> */}
        </div>
        
        <div className='quiz-content-container'>

            <span className="fs-5 fw-bold">Choose Document</span>
            <div className="doc-list" style={{padding: '10px'}}>
                <DocumentsList documentsList={documentsList} handleClickFile={handleClickFile}/>
            </div>
        </div>

        {(theme !== null) &&<div className='quiz-content-container'>
            <Space direction="vertical" style={{width: '100%'}}>
                <span className="fs-5 fw-bold">Questions</span>
                <QuestionList key={theme + '' + getSelectedDocumentIds(documentsList).toString()} hasEdit={true} questionList={questionList} setQuestionList={setQuestionList} defaultPageSize={10} />
                {/* <List
                    itemLayout="vertical"
                    dataSource={questionList}
                    pagination={{position: 'bottom', align: 'center', defaultPageSize: 10, defaultCurrent: current, total:total, onChange: setCurrent, onShowSizeChange: (cur, size)=>{setCurrent(cur); setPageSize(size)}}}
                    renderItem={(item, index) => {
                        switch(item.type){
                            case 1:{
                                return <List.Item
                                    actions={!item.isEdit ? 
                                        [
                                            <a onClick={()=>handleEdit(item)}><Space><EditOutlined /><span>Edit</span></Space></a>,
                                            <a onClick={()=>handleMore(item)}><Space><MoreOutlined /><span>More</span></Space></a>]
                                        : 
                                        [
                                            <a onClick={()=>handleConfirm(item)}><Space><EditOutlined /><span>Confirm</span></Space></a>,
                                            <a onClick={()=>handleCancel(item)}><Space><EditOutlined /><span>Cancel</span></Space></a>
                                        ]
                                    }
                                >
                                    {!item.isEdit ? <SingleChoiceItem item={item} index={index} current={current} pageSize={pageSize}/>
                                    :
                                    <EditSingleChoiceItem  item={item} index={index} handleAnswerChange={(changedValues)=>handleAnswerChange(item, changedValues)} current={current} pageSize={pageSize}/>
                                    }
                                </List.Item>
                            }
                            case 2:{
                                return <List.Item
                                    actions={!item.isEdit ? 
                                        [
                                            <a onClick={()=>handleEdit(item, index)}><Space><EditOutlined /><span>Edit</span></Space></a>,
                                            <a onClick={()=>handleMore(item, index)}><Space><MoreOutlined /><span>More</span></Space></a>]
                                        : 
                                        [
                                            <a onClick={()=>handleConfirm(item, index)}><Space><EditOutlined /><span>Confirm</span></Space></a>,
                                            <a onClick={()=>handleCancel(item)}><Space><EditOutlined /><span>Cancel</span></Space></a>

                                        ]
                                    }
                                >
                                    {!item.isEdit ? <MultipleChoiceItem item={item} index={index} current={current} pageSize={pageSize}/>
                                    :
                                    <EditMultipleChoiceItem  item={item} index={index} handleAnswerChange={(changedValues)=>handleAnswerChange(item, changedValues)} current={current} pageSize={pageSize}/>
                                    }
                                </List.Item>
                            }
                            case 3:{
                                return <List.Item
                                    actions={!item.isEdit ? 
                                        [
                                            <a onClick={()=>handleEdit(item, index)}><Space><EditOutlined /><span>Edit</span></Space></a>,
                                            <a onClick={()=>handleMore(item, index)}><Space><MoreOutlined /><span>More</span></Space></a>]
                                        : 
                                        [
                                            <a onClick={()=>handleConfirm(item, index)}><Space><EditOutlined /><span>Confirm</span></Space></a>,
                                            <a onClick={()=>handleCancel(item)}><Space><EditOutlined /><span>Cancel</span></Space></a>

                                        ]
                                    }
                                >
                                    {!item.isEdit ? <QuestionAndAnswerItem item={item} index={index} current={current} pageSize={pageSize}/>
                                    :
                                    <EditQuestionAndAnswerItem  item={item} index={index} handleAnswerChange={(changedValues)=>handleAnswerChange(item, changedValues)} current={current} pageSize={pageSize}/>
                                    }
                                </List.Item>
                            }
                        }
                    }}
                /> */}
            </Space>
        </div>}
    </> 
}

export default Quiz;